import React, { SVGProps } from 'react';

export function DotIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg {...props} width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<ellipse cx='3.21189' cy='2.83203' rx='2.53611' ry='2.5' fill='#252F35' />
		</svg>
	);
}
